import {useToast} from "vue-toastification";
import {GeneratedZeblineApi} from "~/utils/functions/zebline-api-wrapper";


export default defineNuxtPlugin({
    name: "zebline-api",
    parallel: true,
    order: 1,

    setup() {
        const toast = useToast();
        const runtimeConfig = useRuntimeConfig();
        const accessToken = runtimeConfig.public.ZeblineAccessToken;
        const destination = runtimeConfig.public.ZeblineApi as string;
        const licenceCode = runtimeConfig.public.ZeblineLicenceCode as string;
        const api = new GeneratedZeblineApi(destination, licenceCode);

        api.instance.interceptors.request.use(
            async (config: any) => {
                config.headers.Authorization = `bearer ${accessToken}`;
                return config;
            },
            (error: any) => error
        );

        api.instance.interceptors.response.use(
            (response: any) => response,
            (error: any) => {
                // implementing refresh token call
                const {config, response} = error;
                const originalRequest = config;
                console.log(response);
                toast.error(response.data.message);
                throw error;
            }
        );

        return {provide: {zeblineApi: api}};
    },
});

declare module "#app" {
    interface NuxtApp {
        $zeblineApi: GeneratedZeblineApi<unknown>;
    }
}

declare module "vue" {
    interface ComponentCustomProperties {
        $zeblineApi: GeneratedZeblineApi<unknown>;
    }
}

declare module "@vue/runtime-core" {
    interface ComponentCustomProperties {
        $zeblineApi: GeneratedZeblineApi<unknown>;
    }
}

export {};